<script setup lang="ts">
  import type { ICurrencyData } from '~/store/cashier';

  defineProps<{
    currency: ICurrencyData;
  }>();
</script>

<template>
  <div class="h-[43px] flex items-center gap-2 self-stretch px-4 cursor-pointer text-[#E7E5EC] hover:text-white">
    <CoreImage :src="`/images/currencies/${currency.icon}`" class="size-6" />
    <div class="flex flex-col gap-0.5">
      <span class="text-xl font-semibold leading-[26px]">{{ currency.text }}</span>
      <span class="text-[11px] leading-[15px]">{{ currency.subtitle }}</span>
    </div>
  </div>
</template>
